export default "__VITE_ASSET__D82MRfo9__"